import { SecretSheet, SecretsPage } from '../secrets'

export const AgentSecretsTab = () => (
  <>
    <SecretsPage />
    <div id="side-sheet">
      <SecretSheet />
    </div>
  </>
)
